// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__cyOPC","info":"Panel_info__o1Idm","btns":"Panel_btns__QOg4S","button":"Panel_button__ATKek"};